import { Route, Routes } from 'react-router-dom';
import { RutaProtegidaPanel } from './ProtectedRoute';
import PanelLogin from '../Pages/Panel/PanelLogin';
import AlertasDelDia from '../Pages/Panel/AlertasDelDia';
import Tickets from '../Pages/Panel/Tickets';
import TicketDetalle from '../Pages/Panel/TicketDetalle';
import Reportes from '../Pages/Panel/Reportes';
import GestionUsuarios from '../Pages/Panel/GestionUsuarios';
import GestionRoles from '../Pages/Panel/GestionRoles';
import GestionVias from '../Pages/Panel/GestionVias';
import GestionCategorias from '../Pages/Panel/GestionCategorias';
import ConfiguracionInstancia from '../Pages/Panel/ConfiguracionInstancia';
import GestionComentarios from '../Pages/Panel/GestionComentarios';
import BloqueosIP from '../Pages/Panel/BloqueosIP';
import SinPermiso from '../Pages/Panel/SinPermiso';

/**
 * Árbol de rutas del panel de personal municipal (HU-003), montado bajo
 * `/panel/*` en `routes.js` — rama separada del mapa ciudadano
 * (`PrivateRoutes`), con su propio login y su propio guard de sesión/rol.
 * La ruta raíz (`AlertasDelDia`, HU-004 Fase 1) y `usuarios`/`configuracion`
 * exigen `rolesPermitidos={['ADMINISTRADOR', 'SUPERADMIN']}` — cualquier
 * otro rol autenticado cae en `/panel/sin-permiso` (hoy no hay ninguna
 * sección del panel pensada para `SUPERVISOR`/`COORDINADOR`/`CIUDADANO`).
 */
const PanelRoutes = () => (
  <Routes>
    <Route path="login" element={<PanelLogin />} />
    <Route path="sin-permiso" element={<SinPermiso />} />
    <Route path="tickets" element={
      <RutaProtegidaPanel rolesPermitidos={['ADMINISTRADOR', 'SUPERADMIN']}>
        <Tickets />
      </RutaProtegidaPanel>
    } />
    <Route path="tickets/:id" element={
      <RutaProtegidaPanel rolesPermitidos={['ADMINISTRADOR', 'SUPERADMIN']}>
        <TicketDetalle />
      </RutaProtegidaPanel>
    } />
    <Route path="reportes" element={
      <RutaProtegidaPanel rolesPermitidos={['ADMINISTRADOR', 'SUPERADMIN']}>
        <Reportes />
      </RutaProtegidaPanel>
    } />
    <Route path="usuarios" element={
      <RutaProtegidaPanel rolesPermitidos={['ADMINISTRADOR', 'SUPERADMIN']}>
        <GestionUsuarios />
      </RutaProtegidaPanel>
    } />
    <Route path="roles" element={
      <RutaProtegidaPanel rolesPermitidos={['ADMINISTRADOR', 'SUPERADMIN']}>
        <GestionRoles />
      </RutaProtegidaPanel>
    } />
    <Route path="vias" element={
      <RutaProtegidaPanel rolesPermitidos={['ADMINISTRADOR', 'SUPERADMIN']}>
        <GestionVias />
      </RutaProtegidaPanel>
    } />
    <Route path="categorias" element={
      <RutaProtegidaPanel rolesPermitidos={['ADMINISTRADOR', 'SUPERADMIN']}>
        <GestionCategorias />
      </RutaProtegidaPanel>
    } />
    <Route path="configuracion" element={
      <RutaProtegidaPanel rolesPermitidos={['ADMINISTRADOR', 'SUPERADMIN']}>
        <ConfiguracionInstancia />
      </RutaProtegidaPanel>
    } />
    <Route path="comentarios" element={
      <RutaProtegidaPanel rolesPermitidos={['ADMINISTRADOR', 'SUPERADMIN']}>
        <GestionComentarios />
      </RutaProtegidaPanel>
    } />
    <Route path="bloqueos" element={
      <RutaProtegidaPanel rolesPermitidos={['ADMINISTRADOR', 'SUPERADMIN']}>
        <BloqueosIP />
      </RutaProtegidaPanel>
    } />
    <Route path="*" element={
      <RutaProtegidaPanel rolesPermitidos={['ADMINISTRADOR', 'SUPERADMIN']}>
        <AlertasDelDia />
      </RutaProtegidaPanel>
    } />
  </Routes>
);

export default PanelRoutes;
